import apiClient from "../apiClient";

export const createRunningClub = async (dataRunningClub) => {
  try {
    // console.log("Data runningClub", dataRunningClub);

    const response = await apiClient.post(
      "running-points/createRunningClubs",
      dataRunningClub
    );
    return response?.data;
  } catch (error) {
    // console.log("Error al crear la el club", error);

    throw error;
  }
};

export const getAllRunningsClubsOfProvider = async () => {
  try {
    const response = await apiClient.get("running-points/getAllClubs");
    // console.log("Response RunningsCLubs", response?.data);

    return response?.data?.data ?? [];
  } catch (error) {
    // console.log("Error al obtener runningsClubs", error);

    throw error;
  }
};

export const updateRunning = async (idRunningClub, runningClubData) => {
  try {
    const response = await apiClient.patch(
      `running-points/updateClub/${idRunningClub}`,
      runningClubData
    );
    return response?.data;
  } catch (error) {
    // console.log("Error al actualizar el club", error);

    throw error;
  }
};

export const deleteRunningClub = async (idRunningClub) => {
  try {
    const response = await apiClient.delete(
      `running-points/deleteClub/${idRunningClub}`
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const uploadImageClubAPI = async (clubId, imageData) => {
  try {
    const response = await apiClient.post(
      `running-points/upload-gallery/${clubId}`,
      imageData
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteMemberOfRunningClub = async (idMember, idClub) => {
  try {
    const responseClub = await apiClient.post(
      `running-points/leaveClubAdmin/${idClub}/remove-member/${idMember}`
    );
    return responseClub?.data;
  } catch (error) {
    throw error;
  }
};
